/**@param{import("$lib/types").PublicProduct}product */
export const getUrlProduct = (product) => {
   let url = `/products/${product.url}/${product.sku}`
   return url;
}